import React,{Component,useState} from 'react';
import styles from '../styles/pages/database_detail_player_detail.scss'
import { post } from '../api';
import moment from 'moment'

const  PlayerDetail = props=>{
    const {transferRecord,playerInfo,teamEffect} = props;

    return (
        <div className={['container',styles.player_detail_wrap].join(' ')}>
            <div className={styles.head_wrap}>
                <ul className={styles.left_box}>
                    <li>
                        <img className={styles.poster} src={playerInfo.photo} alt=""/>
                    </li>
                    <li>
                        <p className={styles.team_name}>{playerInfo.nameChs}</p>
                        <p className={styles.team_en_name}>{playerInfo.nameEn}</p>
                    </li>
                </ul>
                <ul className={styles.right_box}>
                    <li>
                        <p><span className={styles.title}>繁体名</span><span className={styles.name}>{playerInfo.nameCht}</span></p>
                        <p><span className={styles.title}>英文名</span><span className={styles.name}>{playerInfo.nameEn}</span></p>
                    </li>
                    <li>
                        <p><span className={styles.title}>生日</span><span className={styles.name}>{playerInfo.birthday}</span></p>
                        <p><span className={styles.title}>国籍</span><span className={styles.name}>{playerInfo.countryCn}</span></p>
                    </li>
                    <li>
                        <p><span className={styles.title}>身高/体重</span><span className={styles.name}>{playerInfo.height}/{playerInfo.weight}</span></p>
                        <p><span className={styles.title}>惯用脚</span><span className={styles.name}>{playerInfo.feetCn}</span></p>
                    </li> 
                    <li>
                        <p><span className={styles.title}>预计身价</span><span className={styles.name}>{playerInfo.expectedValue}</span></p>
                        <p><span className={styles.title}>合同截止期</span><span className={styles.name}>{playerInfo.endDateContract}</span></p>
                    </li> 
                </ul>
            </div>
            <table>
                <thead>
                    <tr>
                        <td className={styles.w448} align="center">现效力球队</td>
                        <td className={styles.w448} align="center">号码</td>
                        <td className={styles.w432} align="center">位置</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        teamEffect.map((v,i)=>{
                            return (
                                <tr key={i}>
                                    <td className={styles.w448} align="center">{v.teamName}</td>
                                    <td className={styles.w448} align="center">{v.number}</td>
                                    <td className={styles.w432} align="center">{v.place}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <div className={styles.transfer_title}>
                转会记录
            </div>
            <table>
                <thead>
                    <tr>
                        <td className="w240" align="center">來自</td>
                        <td className="w240" align="center">去向</td>
                        <td className="w168" align="center">类型</td>
                        <td className="w168" align="center">转会赛季</td>
                        <td className="w168" align="center">转会时间 </td>
                        <td className="w168" align="center">转会费用</td>
                        <td className="w176" align="center">合同到期</td>
                    </tr>
                </thead> 
                <tbody>
                    {
                        transferRecord.map((v,i)=>{
                            return(
                                <tr key={i}>
                                    <td className="w240" align="center">{v.fromTeam}</td>
                                    <td className="w240" align="center">{v.toTeam}</td>
                                    <td className="w168" align="center">{v.typeCn}</td>
                                    <td className="w168" align="center">{v.season}</td>
                                    <td className="w168" align="center">{v.transferTime}</td>
                                    <td className="w168" align="center">{v.money}</td>
                                    <td className="w176" align="center">{v.endTime&&v.endTime!='-'?moment(v.endTime).format("YYYY-MM-DD"):v.endTime}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        transferRecord.length == 0 ? <tr>
                            <td colSpan={7} align="center">暂无记录</td>
                        </tr> : null
                    }
                </tbody>
            </table>
        </div>
    )


}


const getData = (playerId)=>{
    return post('/new/zlk/player/getPlayerDetail',{
        playerId
    }).then(res=>{
        return res.data
    })
}

PlayerDetail.getInitialProps = async (req)=>{
    const playerId = req.query.playerId;
    const [{transferRecord,playerInfo,teamEffect}] = await Promise.all([getData(playerId)])
    return {transferRecord,playerInfo:playerInfo?playerInfo:{},teamEffect}
}



export default PlayerDetail;
